import { Routes } from '@angular/router';
import { ROUTES } from '@shared/constants/routes';

export const dashboardRoutes: Routes = [
  // {
  //   path: ROUTES.EMPLOYEES_MANAGEMENT,
  //   loadComponent: () =>
  //     import('./employees-management/employees-management').then((m) => m.EmployeesManagement)
  // },
  // {
  //   path: 'attendance-sheet',
  //   loadComponent: () =>
  //     import('./attendance-sheet/attendance-sheet').then((m) => m.AttendanceSheetComponent),
  // },
  // {
  //   path: ROUTES.SHIFTS_MANAGEMENT,
  //   loadComponent: () =>
  //     import('./shifts-management/shifts-management').then((m) => m.ShiftsManagement),
  // },
  {
    path: ROUTES.SEPA_DIRECT_DEBIT,
    loadComponent: () =>
      import('./sepa-direct-debit/sepa-direct-debit').then((m) => m.SepaDirectDebit),
  },
  // {
  //   path: ROUTES.GRENS_INVOICING,
  //   loadComponent: () =>
  //     import('./grens-invoicing/grens-invoicing').then((m) => m.GrensInvoicing),
  // },
  // {
  //   path: ROUTES.INVITE_COLLABORATORS,
  //   loadComponent: () =>
  //     import('../invite-collaborators/invite-collaborators').then((m) => m.InviteCollaboratorsComponent)
  // },
  // {
  //   path: ROUTES.DISPUTE_CENTER,
  //   loadComponent: () =>
  //     import('./dispute-center/dispute-center').then((m) => m.DisputeCenterEmployer)
  // },
  // {
  //   path: ROUTES.DISPUTE_CENTER_DETAIL,
  //   loadComponent: () =>
  //     import('./dispute-center/detail-ticket/detail-ticket').then((m) => m.DetailTicketEmployer)
  // },
  {
    path: ROUTES.REFUNDS_MANAGEMENT,
    loadComponent: () =>
      import('./refunds-management/refunds-management').then((m) => m.RefundsManagement)
  },

  // {
  //   path: 'location-management',
  //   children: [
  //     {
  //       path: '',
  //       loadComponent: () => import('./locations-management/locations-management').then((m) => m.LocationsManagement)
  //     },
  //     {
  //       path: 'add',
  //       loadComponent: () => import('./locations-management/add-locations/add-locations').then((m) => m.AddLocation)
  //     },
  //     {
  //       path: ':id',
  //       loadComponent: () => import('./locations-management/locations-details/locations-details').then((m) => m.LocationsDetails)
  //     },
  //     {
  //       path: 'edit/:id',
  //       loadComponent: () => import('./locations-management/edit-locations/edit-locations').then((m) => m.EditLocation)
  //     }
  //   ]
  // }
];
